(function () {
  'use strict';

  if (window.CPManualFeaturedQuickView) return;

  var ACTIVE_CLASS = 'cp-manual-featured-quickshop-active';
  var SECTION_SELECTOR = '.cp-manual-featured';
  var TRIGGER_SELECTOR = SECTION_SELECTOR + ' [data-home-quick-view]';
  var QUICKSHOP_SELECTOR = '[data-quickshop]';

  var lastTrigger = null;
  var quickshop = null;
  var observer = null;
  var focusedLoadedDialog = false;

  function getFocusableElements() {
    if (!quickshop) return [];

    return Array.prototype.slice.call(
      quickshop.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function finishClose() {
    document.body.classList.remove(ACTIVE_CLASS);
    focusedLoadedDialog = false;

    if (
      lastTrigger &&
      document.documentElement.contains(lastTrigger)
    ) {
      lastTrigger.focus();
    }

    lastTrigger = null;
  }

  function syncDialogState() {
    if (!quickshop) return;

    var isVisible = quickshop.classList.contains('quickshop-visible');
    var isLoaded = quickshop.classList.contains('quickshop-loaded');

    if (isVisible && isLoaded && !focusedLoadedDialog) {
      focusedLoadedDialog = true;

      var closeButton = quickshop.querySelector(
        '[data-quickshop-close]'
      );

      if (closeButton) {
        closeButton.focus();
      }
    }

    if (
      !isVisible &&
      document.body.classList.contains(ACTIVE_CLASS)
    ) {
      finishClose();
    }
  }

  function observeQuickshop() {
    quickshop = document.querySelector(QUICKSHOP_SELECTOR);

    if (!quickshop) return;

    /*
     * Prevent duplicate observers.
     */
    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver(syncDialogState);

    observer.observe(quickshop, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function onDocumentClick(event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);

    if (!trigger) return;

    lastTrigger = trigger;
    focusedLoadedDialog = false;

    document.body.classList.add(ACTIVE_CLASS);

    observeQuickshop();

    window.setTimeout(function () {
      if (
        document.body.classList.contains(ACTIVE_CLASS) &&
        (
          !quickshop ||
          !quickshop.classList.contains('quickshop-visible')
        )
      ) {
        finishClose();
      }
    }, 1500);
  }

  function onDocumentKeydown(event) {
    if (
      !document.body.classList.contains(ACTIVE_CLASS) ||
      !quickshop
    ) {
      return;
    }

    /*
     * ESC closes Quick View
     */
    if (event.key === 'Escape') {
      var closeButton = quickshop.querySelector(
        '[data-quickshop-close]'
      );

      if (closeButton) {
        event.preventDefault();
        closeButton.click();
      }

      return;
    }

    /*
     * Keyboard focus trap
     */
    if (
      event.key !== 'Tab' ||
      !quickshop.classList.contains('quickshop-loaded')
    ) {
      return;
    }

    var focusable = getFocusableElements();

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (
      event.shiftKey &&
      document.activeElement === first
    ) {
      event.preventDefault();
      last.focus();

    } else if (
      !event.shiftKey &&
      document.activeElement === last
    ) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener(
    'click',
    onDocumentClick,
    true
  );

  document.addEventListener(
    'keydown',
    onDocumentKeydown
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      observeQuickshop,
      { once: true }
    );
  } else {
    observeQuickshop();
  }

  /*
   * Reinitialize when Shopify Theme Editor
   * reloads the section.
   */
  document.addEventListener(
    'shopify:section:load',
    observeQuickshop
  );

  window.CPManualFeaturedQuickView = {
    observe: observeQuickshop
  };

})();